module.exports = __webpack_public_path__ + "static/img/about-info.ab45eedc.png";